// TODO: this might change, but CORS stops us from loading the

import { DateTime } from 'luxon';
import axios from './axios';

// js file on the client and regexing out the token
const spreedlyEnvironmentToken = 'zpxFDZAKCI522f7ZhB4PXCbSpj';

export declare interface GetPaymentTokenOpts {
    webPaymentsToken: string;

    card?: {
        creditCardNumber: string;
        securityCode: string;
        expireMonth: number;
        expireYear: number;
    };

    bank?: {
        routing: string;
        account: string;
        type: 'checking' | 'savings';
        holderType: 'business' | 'personal';
    };

    firstName?: string;
    lastName?: string;
    fullName?: string;
    company?: string;
    phone: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateCode?: string;
    countryCode3: string;
    zip: string;
}

declare interface getSpreedlyPaymentMethodTokenResp {
    transaction: {
        payment_method: {
            token: string;
        };
    };
}

declare interface getStaxPaymentTokenResp {
    id: string;
}

async function getSpreedlyPaymentMethodToken(opts: GetPaymentTokenOpts): Promise<string> {
    const fullName = (opts.fullName || `${opts.firstName || ''} ${opts.lastName || ''}`).trim();

    if (opts.card) {
        let year: string = String(opts.card.expireYear);
        if (year.length !== 4) {
            year = DateTime.fromFormat(year.slice(-2).padStart(2, '0'), 'yy').toFormat('yyyy');
        }

        return axios.post<getSpreedlyPaymentMethodTokenResp>('https://core.spreedly.com/v1/payment_methods.json', {
            'environment_key': spreedlyEnvironmentToken,
            'payment_method': {
                'credit_card': {
                    'number': opts.card.creditCardNumber,
                    'verification_value': opts.card.securityCode,
                    'full_name': fullName,
                    'month': String(opts.card.expireMonth).padStart(2, '0'),
                    'year': year,
                    'state': opts.stateCode || 'N/A',
                    'country': opts.countryCode3,
                    'company': opts.company,
                    'address1': opts.addressLine1,
                    'address2': opts.addressLine2,
                    'city': opts.city,
                    'zip': opts.zip,
                },
            },
        }, {
            headers: {
                'Spreedly-Environment-Key': spreedlyEnvironmentToken,
            },
            withCredentials: false,
        }).then(resp => resp.data.transaction.payment_method.token);
    } else if (opts.bank) {
        return axios.post<getSpreedlyPaymentMethodTokenResp>('https://core.spreedly.com/v1/payment_methods.json', {
            'environment_key': spreedlyEnvironmentToken,
            'payment_method': {
                'bank_account': {
                    'bank_routing_number': opts.bank.routing,
                    'bank_account_number': opts.bank.account,
                    'bank_account_type': opts.bank.type,
                    'bank_account_holder_type': opts.bank.holderType,
                    'full_name': fullName,
                },
            },
        }, {
            headers: {
                'Spreedly-Environment-Key': spreedlyEnvironmentToken,
            },
            withCredentials: false,
        }).then(resp => resp.data.transaction.payment_method.token);
    }

    throw new Error('"credit" or "bank" is required');
}

export async function GetPaymentToken(opts: GetPaymentTokenOpts): Promise<string> {
    const fullName = (opts.fullName || `${opts.firstName || ''} ${opts.lastName || ''}`).trim();
    let firstName: string = opts.firstName || '';
    let lastName: string = opts.lastName || '';
    if (opts.fullName) {
        const parts = fullName.split(' ');
        firstName = parts.shift() || '';
        lastName = parts.join(' ');
    }

    return axios.post<getStaxPaymentTokenResp>(`https://apiprod.fattlabs.com/webpayment/${opts.webPaymentsToken}/token`, {
        'send_receipt': false,
        'rule': '',
        'total': 0,
        'url': 'https://omni.fattmerchant.com/#/bill/',
        'meta': [],
        'company': opts.company,
        'person_name': fullName,
        'firstname': firstName.trim(),
        'lastname': lastName.trim(),
        'address_zip': opts.zip,
        'email': '',
        'address_country': opts.countryCode3,
        'method': opts.card ? 'card' : 'bank',
        'card_number': opts.card ? '' : undefined,
        'card_exp': opts.card ? `${String(opts.card.expireMonth).padStart(2, '0')}${String(opts.card.expireYear).slice(-2).padStart(2, '0')}` : undefined,
        'bank_account': opts.bank ? opts.bank.routing : undefined,
        'bank_routing': opts.bank ? opts.bank.account : undefined,
        'bank_type': opts.bank ? opts.bank.type : undefined,
        'bank_holder_type': opts.bank ? opts.bank.holderType : undefined,
        'address_1': opts.addressLine1,
        'address_2': opts.addressLine2,
        'address_city': opts.city,
        'address_state': opts.stateCode?.substring(0, 2) || 'NA',
        'payment_token': await getSpreedlyPaymentMethodToken(opts),
    }, {
        withCredentials: false,
    }).then(resp => resp.data.id);
}